const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3002/api';

import api from './api';

// Coordenadas conhecidas para endereços comuns
const KNOWN_ADDRESSES: { [key: string]: { lat: number; lng: number } } = {
  'HMCC - HOSPITAL MUNICIPAL DO TATUAPE': { lat: -23.5505, lng: -46.6333 },
  'HOSPITAL MUNICIPAL DO TATUAPE': { lat: -23.5505, lng: -46.6333 },
  HMCC: { lat: -23.5505, lng: -46.6333 },
  TATUAPE: { lat: -23.5505, lng: -46.6333 },
  'SAO PAULO': { lat: -23.5505, lng: -46.6333 },
  HOSPITAL: { lat: -23.5505, lng: -46.6333 },
  VELORIO: { lat: -23.5505, lng: -46.6333 },
  CEMITERIO: { lat: -23.5505, lng: -46.6333 }
};

// Função para encontrar coordenadas aproximadas
export const findCoordinates = (endereco: string): { lat: number; lng: number } => {
  const enderecoUpper = endereco.toUpperCase();

  // Procurar por palavras-chave conhecidas
  for (const [keyword, coords] of Object.entries(KNOWN_ADDRESSES)) {
    if (enderecoUpper.includes(keyword)) {
      console.log('🎯 Encontrado endereço conhecido:', keyword);
      return coords;
    }
  }

  // Coordenadas padrão de São Paulo se nada for encontrado
  console.log('🔄 Usando coordenadas padrão de São Paulo');
  return { lat: -23.5505, lng: -46.6333 };
};

// Função para geocodificar via API
export const geocodeAddress = async (
  endereco: string
): Promise<{ lat: number; lng: number }> => {
  console.log('🔍 Geocodificando endereço:', endereco);

  try {
    console.log('🌐 Fazendo requisição para API...');
    const response = await api.get(
      `/geocoding/geocode?q=${encodeURIComponent(endereco)}`
    );

    console.log('📡 Resposta da API:', response.status, response);

    if (response.status !== 200) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.data;
    console.log('📊 Dados recebidos:', data);

    if (data.success && data.result && data.result.lat && data.result.lng) {
      const coords = {
        lat: parseFloat(data.result.lat),
        lng: parseFloat(data.result.lng)
      };
      console.log('✅ Coordenadas extraídas da API:', coords);
      console.log('📍 Provider usado:', data.result.provider);
      return coords;
    }

    console.log('⚠️ Nenhuma coordenada encontrada na API, usando fallback');
    return findCoordinates(endereco);
  } catch (error) {
    console.warn(
      '❌ Erro na geocodificação via API, usando coordenadas padrão:',
      error
    );
    return findCoordinates(endereco);
  }
};
